import React from "react";
import { Helmet } from 'react-helmet';
import { ITitleDescription } from "../../Interfaces/base";

const Seo = ({ title, description }: ITitleDescription) => {
  const normalizedContent = Array.isArray(description) ? description.join(", ") : description;

  return (
    <Helmet defer={false} >
      <title>{title}</title>
      <meta name="description" content={normalizedContent} />
    </Helmet>
  );
};

export default Seo;
